import React, { useEffect, useState } from "react";
import { Card, Select, Checkbox, Button, message, Divider, Spin, Empty, Row, Col, Typography } from "antd";
import { CheckCircleOutlined } from "@ant-design/icons"; // Import déplacé ici
import { useDispatch, useSelector } from "react-redux";
import { getSamples } from "../../redux/slices/samples/samplesThunk";
import { getSpecialtiesForFilter } from "../../redux/slices/specialtys/specialtysThunk";
import axiosInstance from "../../services/axiosServicesVisit";

const { Title, Text } = Typography;

const SampleSpecialtyConfig = () => {
  const dispatch = useDispatch();
  const [selectedSample, setSelectedSample] = useState(null);
  const [checkedList, setCheckedList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  const samples = useSelector((state) => state.samples.samples?.data || []);
  const specialties = useSelector((state) => state.specialtys.specialtiesList || []);

  useEffect(() => {
    dispatch(getSamples({ page: 1, limit: 1000 }));
    dispatch(getSpecialtiesForFilter());
  }, [dispatch]);

  const loadLinks = async (sampleId) => {
    setLoading(true);
    try {
      const res = await axiosInstance.get(`/v1/samples/${sampleId}/specialties`);
      setCheckedList(res.data.map(item => item.specialty.id));
    } catch (e) {
      message.error("Erreur de chargement des ciblages");
    } finally {
      setLoading(false);
    }
  };

  const handleSampleChange = (id) => {
    setSelectedSample(id);
    loadLinks(id);
  };

  const onSave = async () => {
    if (!selectedSample) return;
    setSaving(true);
    try {
      await axiosInstance.post(`/v1/samples/${selectedSample}/specialties`, {
        specialtyIds: checkedList
      });
      message.success("Ciblage marketing mis à jour !");
    } catch (e) {
      message.error("Erreur lors de l'enregistrement");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="layout-content">
      <Card 
        bordered={false} 
        title={<Title level={4}>Ciblage Marketing des Échantillons</Title>}
      >
        <Text type="secondary">
          Définissez les spécialités autorisées pour chaque échantillon. 
          Si un délégué distribue un échantillon hors cible, il sera marqué comme "Hors Ciblage" dans les rapports.
        </Text>
        
        <div style={{ marginTop: 30, marginBottom: 24 }}>
          <p><strong>1. Sélectionner l'échantillon :</strong></p>
          <Select
            showSearch
            style={{ width: '100%', maxWidth: 500 }}
            placeholder="Rechercher un échantillon..."
            onChange={handleSampleChange}
            optionFilterProp="children"
            filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
          >
            {samples.map(s => <Select.Option key={s.id} value={s.id}>{s.name}</Select.Option>)}
          </Select>
        </div>

        <Divider />

        {selectedSample ? (
          <Spin spinning={loading}>
            <p><strong>2. Spécialités autorisées pour cet échantillon :</strong></p>
            <div style={{ background: '#fafafa', padding: '30px', borderRadius: '12px', border: '1px solid #f0f0f0' }}>
              <Checkbox.Group 
                style={{ width: '100%' }} 
                value={checkedList}
                onChange={(list) => setCheckedList(list)}
              >
                <Row gutter={[16, 24]}>
                  {specialties.map(spec => (
                    <Col xs={24} sm={12} md={8} lg={6} key={spec.id}>
                      <Checkbox value={spec.id} style={{ fontSize: '14px' }}>
                        {spec.name} {spec.abreviation ? `(${spec.abreviation})` : ''}
                      </Checkbox>
                    </Col>
                  ))}
                </Row>
              </Checkbox.Group>
            </div>
            
            <div style={{ marginTop: 30 }}>
              <Button 
                type="primary" 
                size="large" 
                onClick={onSave} 
                loading={saving}
                icon={<CheckCircleOutlined />}
              >
                Sauvegarder le ciblage
              </Button>
            </div>
          </Spin>
        ) : (
          <div style={{ padding: '40px 0' }}>
            <Empty description="Veuillez sélectionner un échantillon pour configurer ses ciblages spécialités" />
          </div>
        )}
      </Card>
    </div>
  );
};

export default SampleSpecialtyConfig;